// shared/validators/password.helpers.ts

export function hasLowercase(password: string): boolean {
  return /[a-z]/.test(password);
}

export function hasUppercase(password: string): boolean {
  return /[A-Z]/.test(password);
}

export function hasNumber(password: string): boolean {
  return /\d/.test(password);
}

export function hasSpecialChar(password: string): boolean {
  return /[@$!%*?&]/.test(password);
}

export function hasMinLength(password: string, minLength: number = 8): boolean {
  return password?.length >= minLength;
}
